export default __webpack_public_path__ + "media/images/react_icons/key-9871ed0925dbccc924d5275ec63b707b.svg";